import React from "react";

type LogosProps = {
    data: { item: TLogos },
    // TODO define rest of props. (language, defaultLanguage, ...)
}

export default class Logos extends React.Component<LogosProps> {

    public get style() {
        return {};
    }

    render(): React.ReactNode {
        // Module wrapper
        //      Module head
        //      LogosGrid | LogosSlider
        return null;
    }

}